import { Controller } from "@hotwired/stimulus"

// One sponsor slide at a time on the public card statement page. Ported from
// apm_app's sponsors_carousel_controller.js: autoplay, prev/next, dots, swipe.
export default class extends Controller {
  static targets = ["track", "slide", "dot"]
  static values = { delay: { type: Number, default: 4500 }, current: { type: Number, default: 0 } }

  connect() {
    this._touchStartX = 0
    this._resetTimer()
    this.trackTarget.addEventListener("touchstart", this._onTouchStart = this._onTouchStart.bind(this), { passive: true })
    this.trackTarget.addEventListener("touchend", this._onTouchEnd = this._onTouchEnd.bind(this), { passive: true })
  }

  disconnect() {
    clearInterval(this._timer)
    this.trackTarget.removeEventListener("touchstart", this._onTouchStart)
    this.trackTarget.removeEventListener("touchend", this._onTouchEnd)
  }

  next() {
    const count = this.slideTargets.length
    this._moveTo((this.currentValue + 1) % count)
  }

  prev() {
    const count = this.slideTargets.length
    this._moveTo((this.currentValue - 1 + count) % count)
  }

  goTo({ params: { index } }) {
    this._moveTo(index)
  }

  _moveTo(index) {
    this.currentValue = index
    this.trackTarget.style.transform = `translateX(-${index * 100}%)`
    this._updateDots(index)
    this._resetTimer()
  }

  _updateDots(activeIndex) {
    this.dotTargets.forEach((dot, i) => {
      dot.classList.toggle("bg-primary", i === activeIndex)
      dot.classList.toggle("bg-base-300", i !== activeIndex)
    })
  }

  _resetTimer() {
    clearInterval(this._timer)
    if (this.slideTargets.length > 1) this._timer = setInterval(() => this.next(), this.delayValue)
  }

  _onTouchStart(e) {
    this._touchStartX = e.touches[0].clientX
  }

  _onTouchEnd(e) {
    const delta = e.changedTouches[0].clientX - this._touchStartX
    if (Math.abs(delta) < 40) return
    delta < 0 ? this.next() : this.prev()
  }
}
